import { useState, useCallback, useEffect, RefObject } from 'react';
import { useLocation } from 'react-use';
import { AdUtils } from 'src/utils';

interface IProps {
    element?: RefObject<HTMLElement>;
    stickyPosition?: number;
    page: string;
    isIframe?: boolean;
}
export default function useSticky(props: IProps) {
    const { stickyPosition = 50, page, isIframe = false } = props;
    const location = useLocation();
    const [isSticky, setSticky] = useState(false);
    const [pStick, setpStick] = useState<number>(stickyPosition);
    const isPageShowAd = AdUtils.getPageShowAd(page);

    const handleScroll = useCallback(
        (evt: any) => {
            if (isPageShowAd) {
                const adMasthead = document.getElementById('js-masthead');
                const zShortMasthead =
                    document.getElementById('js-zshort-masthead');
                const heightAds =
                    adMasthead?.clientHeight ||
                    zShortMasthead?.clientHeight ||
                    0;
                isIframe ? setpStick(heightAds) : setpStick(heightAds + 50);
            } else {
                setpStick(stickyPosition);
            }

            const window = evt.currentTarget;
            if (window.scrollY > pStick) {
                setSticky(true);
            } else if (window.scrollY < pStick + 5) {
                setSticky(false);
            }
        },
        [isSticky, pStick, page]
    );

    useEffect(() => {
        setpStick(stickyPosition);
    }, [location]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [pStick, page]);

    return [isSticky];
}
